import { render, staticRenderFns } from "./Staffgaji.vue?vue&type=template&id=78426f51"
import script from "./Staffgaji.vue?vue&type=script&lang=js"
export * from "./Staffgaji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports